"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectOptionHierarchy = exports.ToggleIcon = exports.OptionGroupItem = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var Common_1 = require("../Common");
var SelectHierarchy_1 = require("./SelectHierarchy");
var OptionGroupContainer = styled_components_1.default.div.attrs({
    className: 'tws-option-group-container',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin-bottom: 0;\n\t&:last-child {\n\t\tmargin-bottom: ", ";\n\t}\n"], ["\n\tmargin-bottom: 0;\n\t&:last-child {\n\t\tmargin-bottom: ", ";\n\t}\n"])), function (props) { return (props.collapsed ? '0' : null); });
exports.OptionGroupItem = styled_components_1.default.div.attrs({
    className: 'tws-option-group-item',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tpadding: 9px 16px;\n\tpadding-left: ", "px;\n\theight: 46px;\n\tbackground-color: ", ";\n\tfont-size: 10px;\n\tfont-weight: ", ";\n\tborder-bottom: ", " ", " ", ";\n\tline-height: 1.1em;\n\tdisplay: flex;\n\talign-items: center;\n\tcursor: pointer;\n\t&:hover:not([disabled]) {\n\t\tcolor: ", ";\n\t\tbackground-color: ", " !important;\n\t\tlabel {\n\t\t\tcolor: ", " !important;\n\t\t}\n\t\t.tws-input-radio-label::before {\n\t\t\tborder-color: ", " !important;\n\t\t}\n\t}\n"], ["\n\tpadding: 9px 16px;\n\tpadding-left: ", "px;\n\theight: 46px;\n\tbackground-color: ", ";\n\tfont-size: 10px;\n\tfont-weight: ", ";\n\tborder-bottom: ", " ", " ", ";\n\tline-height: 1.1em;\n\tdisplay: flex;\n\talign-items: center;\n\tcursor: pointer;\n\t&:hover:not([disabled]) {\n\t\tcolor: ", ";\n\t\tbackground-color: ", " !important;\n\t\tlabel {\n\t\t\tcolor: ", " !important;\n\t\t}\n\t\t.tws-input-radio-label::before {\n\t\t\tborder-color: ", " !important;\n\t\t}\n\t}\n"])), function (props) { return 16 * props.level; }, function (props) { return (props.collapsed ? globalVars_module_scss_1.default.white : globalVars_module_scss_1.default.gray14); }, globalVars_module_scss_1.default.fontWeightNormal, globalVars_module_scss_1.default.borderThin, globalVars_module_scss_1.default.borderSolid, globalVars_module_scss_1.default.secondaryGray2, globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.mainBlue, globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.white);
exports.OptionGroupItem.displayName = 'OptionGroupItem';
var OptionGroupItemName = styled_components_1.default.span.attrs({
    className: 'tws-option-group-item-name',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\twhite-space: nowrap;\n\toverflow: hidden;\n\tmargin-right: 10px;\n"], ["\n\twhite-space: nowrap;\n\toverflow: hidden;\n\tmargin-right: 10px;\n"])));
OptionGroupItemName.displayName = 'OptionGroupItemName';
var Icons = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tmargin-left: auto;\n"], ["\n\tmargin-left: auto;\n"])));
var SelectedCount = styled_components_1.default.span.attrs({
    className: 'tws-option-group-selected-count',
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tcolor: ", ";\n\tfont-size: 13px;\n\tfont-weight: ", ";\n"], ["\n\tcolor: ", ";\n\tfont-size: 13px;\n\tfont-weight: ", ";\n"])), globalVars_module_scss_1.default.tertiaryGray2, globalVars_module_scss_1.default.fontWeightNormal);
SelectedCount.displayName = 'SelectedCount';
exports.ToggleIcon = styled_components_1.default.span.attrs({
    className: 'tws-option-group-toggle-icon',
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tfont-size: 13px;\n\tmargin-left: ", ";\n"], ["\n\tfont-size: 13px;\n\tmargin-left: ", ";\n"])), globalVars_module_scss_1.default.spacing5);
exports.ToggleIcon.displayName = 'ToggleIcon';
var SelectOptionHierarchy = /** @class */ (function (_super) {
    __extends(SelectOptionHierarchy, _super);
    function SelectOptionHierarchy(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            collapsed: _this.props.collapsed,
        };
        _this.handleOnToggle = _this.handleOnToggle.bind(_this);
        return _this;
    }
    SelectOptionHierarchy.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, item = _a.item, selectedCount = _a.selectedCount;
        var collapsed = this.state.collapsed;
        return (React.createElement(OptionGroupContainer, __assign({}, this.props, { collapsed: this.state.collapsed }),
            React.createElement(exports.OptionGroupItem, __assign({}, this.props, { collapsed: this.state.collapsed, onClick: function (e) { return _this.handleOnToggle(e); } }),
                React.createElement(SelectHierarchy_1.SelectOptionItemNoBorder, null,
                    React.createElement(SelectHierarchy_1.SelectOptionItem, { item: item, selected: this.props.IsSelected(item.name), key: item.name },
                        React.createElement(Common_1.RadioButton, { groupName: 'selectGrp', isChecked: this.props.isChecked, key: item.name, size: 'sm', item: item, handleChange: function () { return _this.props.HandleRadioButtonChange(item.name); }, showTooltips: false }))),
                React.createElement(Icons, null,
                    selectedCount && React.createElement(SelectedCount, null,
                        "(",
                        selectedCount,
                        ")"),
                    React.createElement(exports.ToggleIcon, null,
                        React.createElement(Common_1.Icon, { name: collapsed ? 'angle-down' : 'angle-up' })))),
            !collapsed && React.createElement("div", null, children)));
    };
    SelectOptionHierarchy.prototype.handleOnToggle = function (e) {
        var event = e;
        if (event.target.className.includes('custom-radio') || event.target.type === 'radio' || event.target.tagName === 'LABEL') {
            e.preventDefault();
        }
        else {
            this.setState({ collapsed: !this.state.collapsed });
        }
    };
    SelectOptionHierarchy.defaultProps = {};
    return SelectOptionHierarchy;
}(React.Component));
exports.SelectOptionHierarchy = SelectOptionHierarchy;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
